import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { BaseBean, PageListBean } from "../ds/client_ds.js";
import {
  ExpenseSubTypeBean,
  ExpenseSubTypeSearchCriteria,
  RestExpenseSubTypeListRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class ExpenseSubTypeListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms(e);
  };
  editExpenseSubType = (e, expenseTypeCode, expenseSubTypeCode) => {
    if (e.detail === 1)
      this.props.editExpenseSubType(expenseTypeCode, expenseSubTypeCode);
  };
  deleteExpenseSubType = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteExpenseSubType(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let expenseSubType_list = this.props.expenseSubType_list;
    let expenseSubTypeData = this.props.expenseSubTypeData;
    return (
      <div>
        <div>
          <form>
            <Row>
              <Col sm="1.1">
                <FormLabel id="searchBarLabel">Expense Type Code</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.props.ExpenseTypeOnChange}
                  placeholder="expenseTypeCode"
                  name="expenseTypeCode"
                  value={expenseSubTypeData.expenseTypeCode}
                  lookupRequired={true}
                  lookupHandler={this.props.expenseTypesLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.props.ExpenseTypeEnterKeyEvent}
                  autoCompleteListData={
                    this.props.ExpenseTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.props.displayExpenseTypeAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.ShowAutoCompleteExpenseTypeList
                  }
                  isMandatory={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel id="searchBarLabel">Expense SubType</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  type="text"
                  name="code"
                  onChange={this.props.onChange}
                  value={expenseSubTypeData.code}
                  style={{ "text-transform": "uppercase" }}
                  enterKeyEventHandler={this.props.enterKeyEventHandler}
                  isMandatory={true}
                ></InputTextbox>
              </Col>

              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  className="text-center"
                  onClick={(e) => this.opentypeforms(e)}
                >
                  Go
                </Button>
              </Col>
            </Row>
            <Row></Row>
            <br />
            <br />
          </form>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "expenseTypeCode")
                  }
                >
                  ExpenseTypeCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "expenseTypeCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  ExpenseSubType Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            <tbody>
              {expenseSubType_list.map((Info, index) => (
                <tr key={index} data-item={Info}>
                  <td>{Info.expenseTypeCode}</td>
                  <td className="td_attribute_width">
                    <Button
                      variant="secondry"
                      className="td_attribute_width"
                      onClick={(e) =>
                        this.editExpenseSubType(
                          e,
                          Info.expenseTypeCode,
                          Info.code
                        )
                      }
                    >
                      {Info.code}
                    </Button>
                  </td>
                  <td> {Info.description}</td>

                  <td>{Info.companyCode}</td>
                  <td>{Info.isActive}</td>
                  {/* <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteExpenseSubType(e, Info.code)}
                    >
                      <DeleteIcon />
                    </Button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

class ExpenseSubTypeEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {
      expenseTypes: this.props.expenseTypes,
      showHide: this.props.showHide,
      expenseSubTypeData: this.props.expenseSubTypeData,
    };
  }

  componentDidMount() {
    this.setInputFocus();
  }

  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  saveExpenseSubType = (e) => {
    this.props.saveExpenseSubType(this.state.expenseSubTypeData);
  };

  closeExpenseSubTypeEntryForm() {
    this.props.closeExpenseSubTypeEntryForm();
  }

  render() {
    let isDisableFields = this.props.isDisableFields;
    let expenseSubTypeData = this.props.expenseSubTypeData;
    if (
      isEmptyString(expenseSubTypeData.expenseTypeCode) &&
      expenseSubTypeData.isFetched != true
    ) {
      expenseSubTypeData.expenseTypeCode = "NEW";
    }
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={expenseSubTypeData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>ExpenseType</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="expenseTypeCode"
              type="text"
              placeholder="Enter ExpenseTypeCode"
              onChange={this.onChange}
              value={expenseSubTypeData.expenseTypeCode}
              style={{ "text-transform": "uppercase" }}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              ref={this.codeRef}
              type="text"
              placeholder="Enter ExpenseSubTypeCode"
              onChange={this.onChange}
              value={expenseSubTypeData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          </Row>
          <Row>

          
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={expenseSubTypeData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={expenseSubTypeData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}
class ExpenseSubTypeList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      expenseSubType_list: [],
      response: {},
      pageTitle: "Expense SubType",
      expenseSubTypeData: new ExpenseSubTypeBean(),
      pageList: new PageListBean(),
      criteria: new ExpenseSubTypeSearchCriteria(),
      companyCode: "",
      expenseTypes: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isExpenseSubTypeListFormOpen: true,
      isExpenseSubTypeEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowCode: false,
      ShowAutoCompleteExpenseTypeList: false,
      ExpenseTypePageListForAutoCompleteList: new Array(),
      expenseTypesLookupHandler: null,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    this.loadPage();
    this.cleardata();
    this.loadCacheDetails();
    this.initLookupHandlers();
  }

  moduleCaption = "Expense SubType";

  openeditform = () => {
    this.openExpenseSubTypeEntryForm();
  };

  initLookupHandlers = () => {
    let expenseTypesLookupHandler = new GenericAttributeLookupHandler(
      this.state.expenseTypes,
      "ExpenseTypes"
    );
    this.setState({ expenseTypesLookupHandler: expenseTypesLookupHandler });
  };

  loadCacheDetails = (e) => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));

    this.state.expenseTypes = [];
    let expenseTypes = attribute_cache.expenseTypes;
    if(!isEmptyArray(expenseTypes))
    expenseTypes.map((expenseTypeCode) => {
      this.state.expenseTypes.push(expenseTypeCode);
    });
  };
  opentypeforms = () => {
    let expenseSubTypeData = this.state.expenseSubTypeData.code;
    let expenseTypeCode = this.state.expenseSubTypeData.expenseTypeCode;
    let expenseSubTypeIdvalue = expenseSubTypeData.toUpperCase();
    let expenseTypeIdvalue = expenseTypeCode.toUpperCase();
    let expenseSubTypeList = this.state.expenseSubType_list.filter(
      (expenseSubType) =>
        expenseSubType.code == expenseSubTypeIdvalue &&
        expenseSubType.expenseTypeCode == expenseTypeIdvalue
    );
    let expenseSubTypeObject = null;
    if (expenseSubTypeList !== null) {
      expenseSubTypeObject = expenseSubTypeList[0];
    }
    if (expenseSubTypeObject != null) {
      this.editExpenseSubTypeSearch(expenseSubTypeData, expenseTypeCode);
    } else {
      this.openExpenseSubTypeEntryForm();
    }
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };

  cleardata = () => {
    let expenseSubTypeData = new ExpenseSubTypeBean();
    expenseSubTypeData.companyCode = this.companyCode;
    this.setState({
      expenseSubTypeData: expenseSubTypeData,
      ShowAutoCompleteExpenseTypeList: false,
      ExpenseTypePageListForAutoCompleteList: new Array(),
    });
  };
  saveExpenseSubTypeResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeExpenseSubTypeEntryForm();
      this.state.expenseSubTypeData.expenseTypeCode = "";
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };
  validateExpenseSubType = (expenseSubTypeData) => {
    let isExpenseSubTypeDataData = false;
    let err_list = [];
    let errorMessage = "";
    if (expenseSubTypeData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(expenseSubTypeData.description)) {
        let errMsg = "ExpenseSubType Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(expenseSubTypeData.code)) {
        let errMsg = "ExpenseSubType Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isExpenseSubTypeDataData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isExpenseSubTypeDataData = true;
      this.setState({ isShowAlert: false });
    }
    return isExpenseSubTypeDataData;
  };
  saveExpenseSubType = (expenseSubTypeData) => {
    let isValidLine = false;
    isValidLine = this.validateExpenseSubType(expenseSubTypeData);
    if (isValidLine) {
      if (expenseSubTypeData.isFetched == true) {
        if (
          SecurityAccessManager.ExpenseSubTypeMaintenanceEdit_IsAccessible()
        ) {
          MasterService.updateExpenseSubType(
            expenseSubTypeData,
            this.saveExpenseSubTypeResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Edit Access Denied";
          let errList = this.state.error_list;
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.ExpenseSubTypeMaintenanceCreate_IsAccessible()
        ) {
          MasterService.createExpenseSubType(
            expenseSubTypeData,
            this.saveExpenseSubTypeResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Create Access Denied";
          let errList = this.state.error_list;
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };

  editExpenseSubTypeResponse = (response) => {
    if (response.data != null) {
      if (response.data.expenseSubType != null) {
        let expenseSubTypeData = response.data.expenseSubType;
        this.setState({
          expenseSubTypeData: expenseSubTypeData,
        });
        this.disable();
      }
    }
    this.openExpenseSubTypeEntryForm();
  };
  editExpenseSubType = (expenseTypeCode, expenseSubTypeCode) => {
    let readrestInput = new ExpenseSubTypeSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.expenseType = expenseTypeCode;
    readrestInput.code = expenseSubTypeCode;
    if (SecurityAccessManager.ExpenseSubTypeMaintenanceView_IsAccessible()) {
      MasterService.readExpenseSubType(
        readrestInput,
        this.editExpenseSubTypeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editExpenseSubTypeSearch = (expenseSubTypeCode, expenseTypeCode) => {
    let readrestInput = new ExpenseSubTypeSearchCriteria();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = expenseSubTypeCode;
    readrestInput.expenseType = expenseTypeCode;
    if (SecurityAccessManager.ExpenseSubTypeMaintenanceView_IsAccessible()) {
      MasterService.readExpenseSubType(
        readrestInput,
        this.editExpenseSubTypeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let temp_expenseSubTypedata = this.state.expenseSubTypeData;
    temp_expenseSubTypedata[e.target.name] = e.target.value;
    this.setState({
      expenseSubTypeData: temp_expenseSubTypedata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let expenseSubTypeData = this.state.expenseSubTypeData;
    expenseSubTypeData.companyCode = this.companyCode;
    expenseSubTypeData.code = this.state.expenseSubTypeData.code.toUpperCase();
    expenseSubTypeData.expenseTypeCode =
      this.state.expenseSubTypeData.expenseTypeCode.toUpperCase();
    this.clearError();
    this.saveExpenseSubType(expenseSubTypeData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeExpenseSubTypeEntryForm();
    this.componentDidMount();
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };
  openExpenseSubTypeEntryForm = () => {
    this.setState({
      isExpenseSubTypeListFormOpen: false,
      isExpenseSubTypeEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };
  closeExpenseSubTypeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isExpenseSubTypeListFormOpen: true,
      isExpenseSubTypeEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowCode: false,

      ShowAutoCompleteExpenseTypeList: false,
      ExpenseTypePageListForAutoCompleteList: new Array(),

      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadExpenseSubTypeResponse = (response) => {
    if (response.data != null && response.data.expenseSubTypePageList != null) {
      let expenseSubTypeList = new Array();
      if (!isEmptyArray(response.data.expenseSubTypePageList.expenseSubTypes)) {
        expenseSubTypeList =
          response.data.expenseSubTypePageList.expenseSubTypes;
        expenseSubTypeList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.expenseSubTypePageList.currentPage;
      pageList.pageSize = response.data.expenseSubTypePageList.pageSize;
      pageList.totalCount = response.data.expenseSubTypePageList.totalCount;
      this.setState({
        expenseSubType_list: expenseSubTypeList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new ExpenseSubTypeSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;

    this.loadExpenseSubTypePage(pageInput, criteria);
  };
  loadExpenseSubTypePage = (pageList, searchCriteria) => {
    let criteria = new ExpenseSubTypeSearchCriteria();
    criteria = searchCriteria;

    let requestInput = new RestExpenseSubTypeListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.ExpenseSubTypeMaintenanceView_IsAccessible()) {
      MasterService.getExpenseSubTypesPageList(
        requestInput,
        this.loadExpenseSubTypeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  ExpenseTypeOnChange = (e) => {
    let expenseTypeCode = e.target.value;
    this.state.ShowAutoCompleteExpenseTypeList = true;
    let expenseSubTypeData = this.state.expenseSubTypeData;
    let showAutoCompleteList = this.state.ShowAutoCompleteExpenseTypeList;
    if (isEmpty(expenseTypeCode)) {
      this.state.ShowAutoCompleteExpenseTypeList = false;
      let showAutoCompleteList = this.state.ShowAutoCompleteExpenseTypeList;
      let expenseSubTypeData = this.state.expenseSubTypeData;
      expenseSubTypeData.expenseTypeCode = "";
      let suggestion = [];
      this.setState({
        ShowAutoCompleteList: showAutoCompleteList,
        expenseSubTypeData: expenseSubTypeData,
        ExpenseTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "expenseTypeCode" &&
      showAutoCompleteList === true &&
      expenseTypeCode !== ""
    ) {
      this.readExpenseTypeBySearchString(e.target.value);
      this.readExpenseType(e.target.value);
    }
    expenseSubTypeData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ expenseSubTypeData: expenseSubTypeData });
  };
  ExpenseTypeEnterKeyEvent = (e) => {
    this.readExpenseType(e.target.value);
    this.state.ShowAutoCompleteExpenseTypeList = false;
    let showAutoCompleteList = this.state.ShowAutoCompleteExpenseTypeList;
    this.setState({
      ExpenseTypePageListForAutoCompleteList: new Array(),
      showAutoCompleteList: showAutoCompleteList,
    });
  };
  displayExpenseTypeAutoCompleteList = (ShowAutoCompleteList) => {
    this.setState({
      ShowAutoCompleteExpenseTypeList: ShowAutoCompleteList,
    });
  };
  readExpenseTypeBySearchString = (searchString) => {
    let expenseTypeData = this.state.expenseTypes;
    let simpleAutoCompleteList = new Array();
    if (expenseTypeData.length > 0 && expenseTypeData != null) {
      expenseTypeData.map((obj) => {
        let expenseTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(expenseTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      ExpenseTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readExpenseType = (expenseTypeCode) => {
    let expenseSubTypeData = this.state.expenseSubTypeData;
    let expenseTypeBean = null;
    let expenseTypeData = null;
    this.state.expenseTypes.map((ln) => {
      if (ln.code === expenseTypeCode) {
        expenseTypeBean = ln;
        expenseTypeData = new BaseBean();
        expenseTypeData.code = ln.code;
        expenseTypeData.description = ln.description;
      }
    });
    if (!isEmpty(expenseTypeBean)) {
      expenseSubTypeData.expenseTypeCode = expenseTypeBean.code;
      this.state.ShowAutoCompleteExpenseTypeList = false;
      let showAutoCompleteList = this.state.ShowAutoCompleteExpenseTypeList;
      this.setState({
        expenseSubTypeData: expenseSubTypeData,
        ShowAutoCompleteExpenseTypeList: showAutoCompleteList,
      });
    }
  };
  deleteExpenseSubType = (code, rowData) => {
    //
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.expenseSubType_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ expenseSubType_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isExpenseSubTypeListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isExpenseSubTypeListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isExpenseSubTypeListFormOpen && (
          <ExpenseSubTypeListForm
            {...this.state}
            expenseSubType_list={this.state.expenseSubType_list}
            opentypeforms={this.opentypeforms}
            expenseSubTypeData={this.state.expenseSubTypeData}
            editExpenseSubType={this.editExpenseSubType}
            editExpenseSubTypeSearch={this.editExpenseSubTypeSearch}
            expenseTypes={this.state.expenseTypes}
            loadCacheDetails={this.loadCacheDetails}
            ExpenseTypeOnChange={this.ExpenseTypeOnChange}
            ExpenseTypeEnterKeyEvent={this.ExpenseTypeEnterKeyEvent}
            displayExpenseTypeAutoCompleteList={
              this.displayExpenseTypeAutoCompleteList
            }
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            deleteExpenseSubType={this.deleteExpenseSubType}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isExpenseSubTypeListFormOpen && (
          <ExpenseSubTypeEntryForm
            expenseSubTypeData={this.state.expenseSubTypeData}
            closeExpenseSubTypeEntryForm={this.closeExpenseSubTypeEntryForm}
            saveExpenseSubType={this.saveExpenseSubType}
            editExpenseSubType={this.editExpenseSubType}
            expenseTypes={this.state.expenseTypes}
            isDisableFields={this.state.isDisableFields}
            onChange={this.onChange}
            expenseSubType_list={this.state.expenseSubType_list}
          />
        )}
      </div>
    );
  }
}

function ExpenseSubTypeAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <ExpenseSubTypeList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default ExpenseSubTypeAttributeModule;
